module.exports = __webpack_public_path__ + "static/media/file-doc.07a5f4f0.svg";